import { Trans, useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';

interface RangeIndicatorProps {
  percent: number;
  isDefault: boolean;
}

export function RangeIndicator({ percent, isDefault }: RangeIndicatorProps) {
  const { t } = useTranslation('roster');

  const negativePercent = percent < 0 ? Math.abs(percent) : 0;
  const positivePercent = percent > 0 ? percent : 0;
  const isNegative = percent < 0;
  const displayPercent = isNegative ? negativePercent : positivePercent;

  const textColorClassName = isNegative
    ? 'text-error-default'
    : 'text-success-default';
  const benchmarkTextKey = isNegative
    ? 'benchmarks.percentBelowBenchmark'
    : 'benchmarks.percentAboveBenchmark';
  const centerBarColor = isDefault
    ? 'bg-tertiary-default'
    : 'bg-primary-default';

  return (
    <>
      <div className="w-[10rem]">
        <div className="px-sm">
          <div className="mb-xs text-body-xs text-white">
            <Trans
              t={t}
              i18nKey={benchmarkTextKey}
              components={{
                span: (
                  <span className={cn('font-semibold', textColorClassName)} />
                ),
              }}
              values={{
                percent: displayPercent,
              }}
            />
          </div>
          <div className="flex h-sm gap-2xs rounded-full bg-emphasis-subtle">
            <div className="flex basis-1/2 justify-end">
              <div
                className={cn(
                  'bg-error-default',
                  negativePercent >= 100 && 'rounded-l-full',
                )}
                style={{ flexBasis: `${negativePercent}%` }}
              />
            </div>
            <div className={cn('basis-2xs', centerBarColor)} />
            <div className="flex basis-1/2">
              <div
                className={cn(
                  'bg-success-default',
                  positivePercent >= 100 && 'rounded-r-full',
                )}
                style={{ flexBasis: `${positivePercent}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

RangeIndicator.displayName = 'RangeIndicator';
